import moment from 'moment';
import { InviteStatus, Row, User } from '../../types';

const getInviteStatus = (
  inviteExpires: string,
  inviteStatus: InviteStatus
): InviteStatus | undefined => {
  if (moment().isAfter(inviteExpires) && inviteStatus !== 'accepted')
    return 'expired';
  return inviteStatus !== 'accepted' ? inviteStatus : undefined;
};

export const getUserRow = (user: User): Row => ({
  ...user,
  name: `${user.firstName} ${user.lastName}`,
  userId: user.userId,
  key: user.userId,
  status: user.active ? 'active' : 'inactive',
  options: user,
  emailsAnalyzed:
    user.apps.find((app) => app.name === 'email-analyzer')?.stats
      ?.emailsAnalyzed || 0,
  invitationSent: getInviteStatus(user.inviteExpires, user.inviteStatus),
});
